import {
  API_BASE_URL,
  API_REQUEST
} from 'core/api';


import {
  EXCEPCION_FORM_SUBMIT_TYPES,
  EXCEPCION_FORM,
  EXCEPCION_FORM_EDIT_TYPES,
  EXCEPCION_FORM_REMOVE_TYPES
} from './action-types';

/**
 * Función que se encarga de submitear el formulario
 * 
 * @param {string} endpoint - API endpoint
 * @param {object} data - Los datos a mandar al servidor
 */
export function save(endpoint, data) {
  let url = `${API_BASE_URL}/${endpoint}`;

  if (data.id) {
    url += data.id ? `/${data.id}` : '';
  }

  for (let [k, v] of Object.entries(data)) {
    if (v && typeof v.getMonth === 'function') {
      data[k] = moment(v).format('DD/MM/YYYY');
    }
  }


  return {
    [API_REQUEST]: {
      types: EXCEPCION_FORM_SUBMIT_TYPES,
      config: {
        data: data,
        method: data.id ? 'put' : 'post',
        url: url
      }
    }
  };
}

/**
 * Función que se encarga de generar un DELETE
 * 
 * @param {string} endpoint - API endpoint
 * @param {number} id - El ID del elemento a eliminar
 */
export function remove(endpoint, id) {
  return {
    [API_REQUEST]: {
      types: EXCEPCION_FORM_REMOVE_TYPES,
      config: {
        method: 'delete',
        data: {},
        url: `${API_BASE_URL}/${endpoint}/${id}`
      }
    }
  };
}

/**
 * Función que se encarga de inicializar el state del formulario de creación.
 */
export function form() {
  return {
    type: EXCEPCION_FORM
  };
}

/**
 * Función que se encarga de inicializar el state del formulario de edición.
 * 
 * @param {number} id - ID del elemento a editar.
 */
export function formEdit(endpoint, id) {
  return {
    [API_REQUEST]: {
      types: EXCEPCION_FORM_EDIT_TYPES,
      config: {
        data: {},
        method: 'get',
        url: `${API_BASE_URL}/${endpoint}/${id}`
      }
    }
  };
}


// WEBPACK FOOTER //
// ./src/core/services/excepcion-form/action-creators.js